import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mall-my-profile" }
const _hoisted_2 = {
  key: 0,
  class: "mall-my-profile__card"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mall-my-profile__actions" }
const _hoisted_6 = ["disabled"]

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useMemberAuth } from '@/composables/useMemberAuth'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallMyProfilePage',
  setup(__props) {

const router = useRouter()
const { member, withdraw } = useMemberAuth()
const isKakaoMember = computed(() => member.value?.loginType === 'kakao')
const kakaoAccountLabel = computed(() =>
  member.value?.oauthEmail ? `카카오 계정 · ${member.value.oauthEmail}` : '카카오 계정',
)
const withdrawing = ref(false)

const onWithdraw = async () => {
  if (withdrawing.value) {
    return
  }
  if (
    !window.confirm(
      '정말 탈퇴할까요?\n카카오 계정이면 같은 카카오로 다시 가입할 수 있습니다.\n주문 기록은 보관됩니다.',
    )
  ) {
    return
  }
  withdrawing.value = true
  try {
    await withdraw()
    window.alert('탈퇴가 완료되었습니다.')
    await router.push({ name: 'dashboard' })
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '탈퇴에 실패했습니다.')
  } finally {
    withdrawing.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("header", { class: "mall-my-list__head" }, [
      _createElementVNode("h1", null, "개인정보 확인 / 수정"),
      _createElementVNode("p", null, "기관·담당자 정보는 계정 설정에서 관리합니다.")
    ], -1)),
    (_unref(member))
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("dl", null, [
            (isKakaoMember.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("dt", null, "로그인", -1)),
                  _createElementVNode("dd", null, _toDisplayString(kakaoAccountLabel.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createElementVNode("dt", null, "아이디", -1)),
                  _createElementVNode("dd", null, _toDisplayString(_unref(member).userId), 1)
                ])),
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("dt", null, "기관명", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(member).orgName || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("dt", null, "기관 기호", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(member).longtermCode || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("dt", null, "담당자", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(member).bossName || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("dt", null, "휴대폰", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(member).bossPhone || '-'), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("dt", null, "이메일", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(member).bossEmail || '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/my-info",
              class: "mall-my-profile__primary"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("정보 수정하기", -1)
              ]))]),
              _: 1
            }),
            (!isKakaoMember.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/find-password",
                  class: "mall-my-profile__ghost"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" 비밀번호 변경 ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "mall-my-profile__withdraw",
            disabled: withdrawing.value,
            onClick: onWithdraw
          }, _toDisplayString(withdrawing.value ? '탈퇴 중...' : '계정 탈퇴'), 9, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})